import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import missionService from '../../services/missionService';
import reportService from '../../services/reportService';
import { getUser } from '../slices/authSlice';

// Estado inicial
const initialState = {
  missions: [],
  currentMission: null,
  isLoading: false,
  error: null,
  initialized: false
};

// Thunks
export const fetchMissions = createAsyncThunk(
  'missions/fetchAll',
  async (_, { rejectWithValue, getState }) => {
    try {
      const { auth } = getState();
      const user = auth.user;
      
      // Si es usuario de empresa (pero no piloto ni staff), cargar reportes en lugar de misiones
      if (user?.is_enterprise_user && !user?.is_pilot && !user?.is_staff) {
        console.log('Cargando reportes para usuario de empresa');
        const reports = await reportService.getEnterpriseReports();
        return reports;
      } else if (user?.is_pilot) {
        // Para pilotos, cargar misiones asignadas al piloto
        console.log('Cargando misiones para piloto');
        const missions = await missionService.getPilotMissions();
        return missions;
      } else {
        // Para otros usuarios (staff), cargar todas las misiones
        console.log('Cargando todas las misiones para staff');
        const missions = await missionService.getAllMissions();
        return missions;
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || 
        'Error al cargar los datos'
      );
    }
  }
);

export const fetchMissionById = createAsyncThunk(
  'missions/fetchById',
  async (id, { rejectWithValue }) => {
    try {
      const mission = await missionService.getMissionById(id);
      return mission;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.detail || 
        'Error al cargar la misión'
      );
    }
  }
);

// Slice
const missionSlice = createSlice({
  name: 'missions',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearCurrentMission: (state) => {
      state.currentMission = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch All Missions
      .addCase(fetchMissions.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMissions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.missions = action.payload;
        state.initialized = true;
      })
      .addCase(fetchMissions.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      
      // Fetch Mission By ID
      .addCase(fetchMissionById.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchMissionById.fulfilled, (state, action) => {
        state.isLoading = false;
        state.currentMission = action.payload;
      })
      .addCase(fetchMissionById.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  }
});

export const { clearError, clearCurrentMission } = missionSlice.actions;
export default missionSlice.reducer;